import React from 'react'

const FacebookIcon = () => {
  return (
    <svg className="icon facebook-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
    </svg>
  )
}

export default FacebookIcon


// WEBPACK FOOTER //
// ./src/assets/icons/facebook-icon.js